import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import FormGroup from 'react-bootstrap/FormGroup';
import Col from 'react-bootstrap/Col';
import FormControl from 'react-bootstrap/FormControl';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import Link from '../../Link';
import Loader from '../../Common/Loader';
import GooglePolygonMap from '../../Common/GooglePolygonMap';

import messages from '../../../locale/messages';
import submit from './submit';
import validate from './validate';

import s from './ManageLocation.css';
import bt from '../../../components/commonStyle.css';

class ManageLocationForm extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };
  constructor(props) {
    super(props);
  }
  static defaultProps = {
    loading: false
  };

  handlePlaceChanged() {
    const place = this.autocomplete.getPlace();
    this.props.onPlaceLoaded(place);
  }
  renderFormControl = ({ input, label, type, meta: { touched, error }, className, note }) => {
    const { formatMessage } = this.props.intl;
    return (
      <FormGroup className={s.formGroup}>
        <div className={bt.noPadding}>
          <label className={bt.labelText} >{label}</label>
          <FormControl {...input} placeholder={label} type={type} className={bt.formControlInput} />
          {
            note && <p className={cx(s.subtext, 'textWhiteTwo')}>{note}</p>
          }
          {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
        </div>
      </FormGroup>
    );
  }
  renderTextAreaField = ({ input, label, type, meta: { touched, error }, children, labelClass, fieldClass, placeholder }) => {
    const { formatMessage } = this.props.intl;
    return (
      <Form.Group className={s.formGroup}>
        <label className={bt.labelText} >{label}</label>
        <Form.Control as="textarea" rows="3" {...input} placeholder={placeholder} type={type} className={fieldClass} />
        {touched && error && <span className={cx(bt.errorMessage, 'errorRTL')}>{formatMessage(error)}</span>}
      </Form.Group>
    )
  }
  render() {
    const { error, handleSubmit, submitting, dispatch, title, loading, isEditForm, initialValues } = this.props;
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx(s.pagecontentWrapper, 'mapSection')}>
        <Container className={s.containerWith}>
          <div className={s.contentBox}>
            <h1 className={cx('textAlignRightRTL', s.headingTwo, 'textWhite')}>{formatMessage(isEditForm ? messages.editLocation : messages.addLocation)}</h1>
            <Form onSubmit={handleSubmit(submit)} >
              <Row>
                <Col lg={6} md={6} sm={12} xs={12}>
                  {error && <strong>{error}</strong>}
                  <Field
                    name="locationName"
                    type="text"
                    component={this.renderFormControl}
                    label={formatMessage(messages.nameOnly)}
                    className={cx(bt.formControlInput, bt.space2)}
                  />

                  {isEditForm &&
                    <div className={bt.space3}>
                      <label className={bt.labelText} >{formatMessage(messages.status)}</label>
                      <Field name="isActive" className={cx(bt.formControlSelect, bt.formControlInput)} component="select">
                        <option value={true}>{formatMessage(messages.active)}</option>
                        <option value={false}>{formatMessage(messages.inactive)}</option>
                      </Field>
                    </div>

                  }

                  <Field
                    name="description"
                    type="text"
                    placeholder={formatMessage(messages.description)}
                    component={this.renderTextAreaField}
                    label={formatMessage(messages.description)}
                    labelClass={bt.labelText}
                  />

                </Col>
                <Col lg={6} md={6} sm={12} xs={12}>
                  <div className={s.relative}>
                    {isEditForm && initialValues?.path ? <GooglePolygonMap
                      formName={'ManageLocationForm'}
                      fieldName={'path'}
                       paths={initialValues?.path}
                    /> :  <GooglePolygonMap
                    formName={'ManageLocationForm'}
                    fieldName={'path'}
                    
                  />}
                  </div>
                </Col>
              </Row>

              <div className={cx(bt.textAlignRight, bt.spaceTop4, 'textAlignLeftRTL', 'loadingBtnRTL')}>
                <Form.Group className={s.formGroup}>
                  <div className={s.displayInlineBlock}>
                    <Loader
                      type={"button"}
                      label={formatMessage(messages.submitButton)}
                      show={loading}
                      buttonType={'submit'}
                      className={cx(bt.btnPrimary)}
                      disabled={submitting || loading}
                      isSuffix={true}
                    />
                  </div>
                  <Link to={"/siteadmin/location"} className={cx(s.backBtn, bt.btnSecondary, 'backBtnRTL', s.displayInlineBlock)} >{formatMessage(messages.goBack)}</Link>
                </Form.Group>
              </div>
            </Form>
          </div>
        </Container>
      </div>
    );
  }
}
ManageLocationForm = reduxForm({
  form: 'ManageLocationForm',
  onSubmit: submit,
  validate
})(ManageLocationForm);

const mapState = (state) => ({
  loading: state.loader.AddLocation
});
const mapDispatch = {};
export default injectIntl(compose(
  withStyles(s, bt),
  connect(mapState, mapDispatch)
)(ManageLocationForm));
